module.exports = __webpack_public_path__ + "img/密码.0be34fc9.svg";